import React from 'react'
import PropTypes from 'prop-types'
import exact from 'prop-types-exact'
import { IonList } from '@ionic/react'

import TripImage from './TripImage'
import * as Types from 'types'

const propTypes = {
  selectImage: PropTypes.func.isRequired,
  questions: PropTypes.arrayOf(Types.TripQuestionResponse),
}
const defaultProps = {
  questions: [],
}

function TripQuestionnaireResponse({ questions, selectImage }) {
  if (questions.length === 0) return null

  return questions.map((question, index) => {
    const { questionText } = question

    return (
      <div key={index}>
        <h4>{questionText}</h4>
        <QuestionResponse question={question} selectImage={selectImage} />
      </div>
    )
  })
}

TripQuestionnaireResponse.propTypes = exact(propTypes)
TripQuestionnaireResponse.defaultProps = defaultProps

export default React.memo(TripQuestionnaireResponse)

function QuestionResponse({ question, selectImage }) {
  const { questionResponse, type } = question

  switch (type) {
    case Types.QUESTION_TYPE.CHOICE:
    case Types.QUESTION_TYPE.INPUT:
    case Types.QUESTION_TYPE.TEXTAREA:
      return <p>{questionResponse}</p>

    case Types.QUESTION_TYPE.PHOTO: {
      return (
        <IonList lines="none">
          {questionResponse.length > 0 ? (
            questionResponse.map((image) => (
              <TripImage
                key={image.id}
                image={image}
                onClick={() => selectImage(image)}
              />
            ))
          ) : (
            <p>No images</p>
          )}
        </IonList>
      )
    }
    default:
      return questionResponse ? <p>{questionResponse}</p> : null
  }
}
